<template>
  <el-dialog class="dialog-info" :title="pageType == 'add' ? '新增': pageType == 'edit' ? '编辑':'查看'" @close="onCancel" :visible.sync="dialogVisible" :width="'600px'">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="藏品编号 :" prop="collectCode">
        <el-input v-model="form.collectCode" :disabled="pageType == 'detail'" placeholder="请输入姓名" />
      </el-form-item>

      <el-form-item label="藏品名称 :" prop="collectName">
        <el-input v-model="form.collectName" :disabled="pageType==='detail'"
          :placeholder="pageType  == 'detail'? '' : '请输入'"></el-input>
      </el-form-item>

      <el-form-item label="藏品类型 :" prop="collectType">
        <el-select style="width: 100%" v-model="form.collectType"
          :placeholder="pageType == 'detail' ? '' : '请选择'" :disabled="pageType === 'detail'">
          <el-option v-for="item in typeList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="总登记号 :" prop="signCode">
        <el-input v-model="form.signCode" :disabled="pageType==='detail'"
          :placeholder="pageType  == 'detail'? '' : '请输入'"></el-input>
      </el-form-item>

      <el-form-item label="分类号 :" prop="typeCode">
        <el-input v-model="form.typeCode" :disabled="pageType==='detail'"
          :placeholder="pageType  == 'detail'? '' : '请输入'"></el-input>
      </el-form-item>

      <!-- <el-form-item label="类别?? :" prop="name">
        <el-input v-model="form.name" :disabled="pageType==='detail'"
          :placeholder="pageType  == 'detail'? '' : '请输入'"></el-input>
      </el-form-item> -->

      <el-form-item label="年代 :" prop="collectYear">
        <el-cascader style="width: 100%"
          :disabled="pageType === 'detail'" 
          v-model="year1" 
          :options="platOptions"
          @active-item-change="handleItemChange" 
          :props="props">
        </el-cascader>
      </el-form-item>

      <el-form-item label="级别 :" prop="collectLevel">
        <el-select style="width: 100%" v-model="form.collectLevel"
          :placeholder="pageType == 'detail' ? '' : '请选择'" :disabled="pageType === 'detail'">
          <el-option v-for="item in levelList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="藏品图片：">
        <el-upload ref="upload1" :file-list="fileList1" action="/singleMuseum/attach/upload"
          list-type="picture-card" :disabled="pageType == 'detail'" accept="image/*" :data="configData"
          :on-remove="(response, file, fileList) => { handleUnitPicRemove(response, file, '1') }"
          :on-success="(response, file, fileList) => { handleUnitPicSuccess(response, file, fileList, '1') }"
          :before-upload="beforeUnitPicUpload" multiple>
          <div class="img-uploader">
            <i class="el-icon-plus"></i>
            <span>上传藏品图片</span>
          </div>
          <div class="pic-list" slot="file" slot-scope="{file}">
            <img :src="file.url" mode="heightFix" alt="" class="el-upload-list__item-thumbnail"
              :ref='"file_" + file.uid'>
            <span class="el-upload-list__item-actions">
              <!-- <span class="el-upload-list__item-preview" @click="rotateImg(file, '2')"><i class="el-icon-refresh-left"></i></span> -->
              <span class="el-upload-list__item-delete" @click="handleRemove(file, fileList1, '1')"><i class="el-icon-delete"></i></span>
              <!-- <span class="el-upload-list__item-rotate" @click="rotateImg(file, '1')"><i class="el-icon-refresh-right"></i></span> -->
            </span>
          </div>
        </el-upload>

      </el-form-item>

      <!-- <el-form-item label="文件类型 :" prop="name">
        <el-input v-model="form.name" :disabled="pageType==='detail'"
          :placeholder="pageType  == 'detail'? '' : '请输入'"></el-input>
      </el-form-item> -->

      <!-- <el-form-item label="图片 :" prop="phone">
        <div class="sch-box">
          <el-upload class="avatar-uploader" action="/singleMuseum/attach/upload" accept="image/*" :data="configData"
            :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"
            v-if="pageType!=='detail'">
            <img v-if="imgUrl" style="height:150px;width:100%;object-fit:contain;" :src="imgUrl" class="avatar">
            <div v-else>
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <div class="el-upload__text">上传图片</div>
            </div>
          </el-upload>

          <div class="pic-box" v-if="pageType==='detail'">
            <img :src="imgUrl" alt="">
          </div>
        </div>
      </el-form-item> -->


    </el-form>
    <div class="dialog-footer tr mt-30" v-if="pageType != 'detail'">
      <el-button @click="onCancel">取 消</el-button>
      <el-button type="primary" @click="onSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Sortable from 'sortablejs'

import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['imageTypes']),
  },
  data() {
    return {
      pageType: 'add',
      dialogVisible: false,
      form: {

      },
      typeList: [],
      levelList: [],
      year1: '',
      platOptions: [],
      props: {
        label: 'dictName',
        value: 'dictCode',
        children: 'child',
        checkStrictly: true
      },
      configData: {
        tableName: 'qgCollect'
      },
      imgUrl: '',

      fileList1: [],
      pictureIds: [],

      rules: {
        collectCode: [{ required: true, message: '不能为空', trigger: 'blur' }],
        collectName: [{ required: true, message: '不能为空', trigger: 'blur' }],
        // signCode: [{ required: true, message: '不能为空', trigger: 'blur' }],
        // typeCode: [{ required: true, message: '不能为空', trigger: 'blur' }],
      }
    }
  },
  methods: {
    init(item, type) {
      this.initSelect()

      this.pageType = type
      this.dialogVisible = true
      console.log(234, this.pageType)

      if(type !== 'add') {
        this.form.id = item.id
        this.getDetail()
      }

      this.$nextTick(() => {
        this.initDragSort2()
      })
    },
    getDetail() {
      this.$http.get('/qinggong/qgCollectPostscript/detail', {
        id: this.form.id
      }).then(res => {
        if (res.success) {
          this.form = res.result

          console.log(this.form)
          // this.imgUrl = res.result.imgUrl
        }
      })
    },
    initSelect(id) {
      this.$http
        .post('/collectDict/getSelectDataByArr', {
          arr: [
            'collection_year',
            'collection_level',
            'qing_type'
          ]
        })
        .then((res) => {
          var success = res.success
          if (success) {
            var data = res.result
            this.typeList = data.qing_type
            this.levelList = data.collection_level
            this.platOptions = data.collection_year
            this.platOptions.map((item, index, array) => {
              // 因为数组和对象更新后不会更新视图，这里必须用$set方法
              this.$set(array[index], 'child', [])
            })
            console.log('platOptions', this.platOptions)

            // if (id) {
            //   this.getDetail(id)
            // }
          }
        })
    },
    handleItemChange(value) {
      // 动态/异步加载分类数据
      let parentId = ''
      // this.addForm.collectDetailYear = ''
      if (value.length === 1) {
        // 如果点击的是一级分类
        parentId = value[0]
        this.platOptions.map((item, index) => {
          if (item.dictCode === parentId && item.child.length === 0) {
            // 当顶级分类的的child为空时才请求数据
            this.$http
              .post('/collectDict/getDictListByPid', { pid: parentId })
              .then((res) => {
                if (res.success) {
                  this.$set(this.platOptions[index], 'child', res.result)
                  item.child.map((innerItem, innerIndex) => {
                    // 二级分类下必须要设置一个空的child数组，不然点击@active-item-change没反应
                    this.$set(item.child[innerIndex], 'child', [])
                  })
                }
              })
          }
        })
      } else {
        // 如果点击的是二级分类，则直接将三级分类绑定到platOptions
        parentId = value[1]
        this.platOptions.map((item, index) => {
          item.child.map((innerItem, innerIndex) => {
            if (
              innerItem.dictCode === parentId &&
              innerItem.child.length === 0
            ) {
              // 当二级分类的的child为空时才请求一次数据
              this.$http
                .post('/collectDict/getDictListByPid', { pid: parentId })
                .then((res) => {
                  if (res.success) {
                    this.$set(item.child[innerIndex], 'child', res.result)
                  }
                })
            }
          })
        })
      }
    },

    initDragSort2() {
      // 支持拖拽排序
      const el = this.$refs.upload1.$el.querySelectorAll('.el-upload-list')[0]
      Sortable.create(el, {
        onEnd: ({ oldIndex, newIndex }) => {
          // 交换位置
          const arr = this.fileList1
          const page = arr[oldIndex]
          let tempIds = []
          arr.splice(oldIndex, 1)
          arr.splice(newIndex, 0, page)
          arr.map((item) => {
            if (item.response && item.response.result) {
              tempIds.push(item.response.result.attId)
            } else {
              if (item.url) {
                let tempUrl = item.url.split('=')
                let attId = tempUrl[1].split('&')[0]
                tempIds.push(attId)
              }
            }
          })


          console.log(111, tempIds)
          this.pictureIds = tempIds
        }
      })
    },

    handleUnitPicRemove(file, fileList, type) {
      console.log(fileList)
      if (type == 1) {
        this.pictureIds = []
      }
      if (fileList && fileList.length > 0) {
        fileList.map((item) => {
          if (item.response && item.response.result) {
            if (type == 1) {
              this.pictureIds.push(item.response.result.attId)
            }
          } else {
            // 修改状态
            if (item.url) {
              let arr = item.url.split('&'),
                arr1 = arr[0].split('=')

              if (type == 1) {
                this.pictureIds.push(arr1[1])
              }
            }
          }
        })
      }
    },

    // 上传团队图片
    beforeUnitPicUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2
      const fileName = file.name
      const fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
      // if (!isLt2M) {
      //   this.$message({
      //     message: '上传文件大小不能超过 2MB!',
      //     type: 'warning'
      //   })
      //   return
      // }

      if (this.imageTypes.includes(fileType)) {
        return true
      } else {
        this.$message.error('请上传正确的图片类型')
        return
      }
    },

    handleUnitPicSuccess(res, file, fileList, type) {
      if (res.success) {
        this.$message.success('上传成功')
        if (type == 1) {
          this.fileList1 = fileList
          this.pictureIds.push(res.result.attId)
        }
      } else {
        let index = 0
        for (const i in fileList) {
          if (fileList[i] == file) {
            index = i
            break
          }
        }
        //移出当前文件对象
        fileList.splice(index, 1)
        this.$message.error(res.message)
      }
    },

    rotateImg(file, type) {
      if (!file.rotate) {
        this.$set(file, 'rotate', 0)
      }
      if (file.response && file.response.success) {
        if (file.response.result) {
          let attId = file.response.result.attId
          this.$http
            .get('/attach/rotatePicture', {
              id: attId,
              type: type
            })
            .then((res) => {
              if (res.success) {
                if (type == 1 || type == 3) {
                  file.rotate += 90
                }
                if (type == 2 || type == 4) {
                  file.rotate -= 90
                }
                this.$refs[
                  'file_' + file.uid
                ].style.transform = `rotate(${file.rotate}deg)`
                this.$message.success('旋转成功')
              }
            })
        }
      } else {
        var keyValue = file.url.split('=')
        var key = keyValue[0]
        var value = keyValue[1]

        if (value) {
          let keyValue1 = value.split('&'),
            attId = keyValue1[0]
          this.$http
            .get('/attach/rotatePicture', {
              id: attId,
              type: type
            })
            .then((res) => {
              if (res.success) {
                if (type == 1) {
                  file.rotate += 90
                } else {
                  file.rotate -= 90
                }
                this.$refs[
                  'file_' + file.uid
                ].style.transform = `rotate(${file.rotate}deg)`
                this.$message.success('旋转成功')
              }
            })
        }
      }
    },

    handleRemove(file, fileList, type) {
      let newList = fileList.filter((item) => {
        return item.uid != file.uid
      })

      if (type == 1) {
        this.pictureIds = []
        this.fileList1 = newList
      }
      if (newList && newList.length > 0) {
        newList.map((item) => {
          if (item.response && item.response.result) {
            if (type == 1) {
              this.pictureIds.push(item.response.result.attId)
            }
          } else {
            // 修改状态
            if (item.url) {
              let arr = item.url.split('&'),
                arr1 = arr[0].split('=')

              if (type == 1) {
                this.pictureIds.push(arr1[1])
              }
            }
          }
        })
      }
    },


    beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2
      const fileName = file.name
      const fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
      // if (!isLt2M) {
      //   this.$message({
      //     message: '上传文件大小不能超过 2MB!',
      //     type: 'warning'
      //   })
      //   return
      // }

      if (this.imageTypes.includes(fileType)) {
        return true

      } else {
        this.$message.error(
          '请上传正确的图片类型'
        )
        return
      }
    },

    handleAvatarSuccess(res) {
      if (res.success) {
        this.$message.success('上传成功')
        this.imgUrl = res.result.attPath
        if (this.pageType == 'edit') {
          this.form.imgUrl = res.result.attPath
        }
        this.form.attId = res.result.attId
      } else {
        this.$message.error(res.message)
      }
    },

    // 文件上传回调
    uploadCallback(fileStr) {
      this.form.fileIds = fileStr
    },
    onCancel() {
      this.dialogVisible = false
      this.form = {}
      this.$refs["form"].clearValidate()
    },

    onSubmit() {
      console.log(this.form)

      // debugger
      // const self = this
      this.$refs["form"].validate((valid) => {
        if (valid) {
          // let url = "addAddressBook"
          // if (this.form.id) {
          //   url = "updateAddressBook"
          // }

          this.$http.post('/qinggong/qgCollect/save', {
            ...this.form,
            // imgIds: this.form.attId
            imgIds: this.pictureIds.join(',')
          })
          .then(res => {
            this.loadingSave = false
            if (res.success) {
              if (this.pageType === 'edit') {
                this.$message.success('编辑成功')
              } else if (this.pageType === 'add') {
                this.$message.success('创建成功')
              }

              this.onCancel()
              this.$emit('refresh')
            } else {
              this.$message.error(res.message)
            }
          })
          .catch(() => {
            this.loadingSave = false
          })

          return
          this.$api.workbench[url](this.form).then(res => {
            if (res.success) {
              this.$message.success({
                message: this.form.id ? '修改成功' : '新增成功',
                onClose() {
                  self.dialogVisible = false
                  self.form = {}
                  self.getData()
                }
              })
            }
          })
        } else {
          return false;
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.dialog-info {
  .sch-box {
    margin-bottom: 20px;

    .pic-box {
      text-align: center;
      margin-bottom: 30px;
      img {
        max-width: 60%;
      }
    }
  }

  .img-uploader {
    cursor: pointer;
    height: 100%;
    line-height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .avatar-uploader {
    width: 50%;
    border: 1px dashed #8c939d;
    min-height: 150px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .el-upload {
      width: 100%;
      height: 150px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .el-icon-plus {
      font-size: 20px;
    }

    .el-upload__text {
      line-height: 1;
    }
  }

  .el-upload-list {
    .pic-list {
      width: 100%;
      height: 100%;
      .el-upload-list__item-thumbnail {
        object-fit: contain;
      }
    }
  }
}
</style>
